import React from 'react';
import {  Modal, Button } from 'react-bootstrap';
import { useTranslation } from "react-i18next";

const Dialog = (props) => {
    const {t,i18n} = useTranslation()
    return (
        <>
        <Modal show={props.show} animation={false} onClick={(e) => e.stopPropagation()} style={{zIndex:9999}}>
            <Modal.Header>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{props.message}</Modal.Body>
            <Modal.Footer>
                {props.button}
                <Button variant="secondary" onClick={props.handleClose}>{t("common.close")}</Button>
            </Modal.Footer>
        </Modal>
        </>
    )
}

export default Dialog;
